import { MeshLayerState } from '../../../../core/outputs/annotation/annotation-shared/state/layers/mesh-layer-state';
import { AnnotationState } from '../../annotation-shared/state/root/annotation-state';

export class PointCloudState extends AnnotationState {
  override layers!: MeshLayerState[];
  sideViewsIsAllowed!: boolean;
}
